package com.eladfinish.bible.contest.screens.pyramidCrossword.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.answers_list
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.ic_help
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.PyramidCrosswordToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.persistentListOf

enum class PyramidToolbarId {
    HELP,
    SOLUTIONS,
}

@Composable
internal fun PyramidMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<PyramidCrosswordToolbarAction>,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.Pyramid,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = persistentListOf(
                ToolbarActionConfig.IconAction(
                    id = PyramidToolbarId.HELP,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_help)
                    ),
                    menuText = SharedRes.strings.help.desc(),
                    onClick = {
                        toolbarEmitter.emit(PyramidCrosswordToolbarAction.Help)
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = PyramidToolbarId.SOLUTIONS,
                    stringDesc = SharedRes.strings.answers_list.desc(),
                    onClick = {
                        toolbarEmitter.emit(PyramidCrosswordToolbarAction.Solutions)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            )
        )
    )
}
